import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values  = { 
    url: String ,
    filename: String,
    contentType: String
  }
  static targets = ["image" , "video", "downloadButton"]
  static classes = ["hidden", "scrollLock"]

  // --- BROADCASTER (Thumbnail) ---
  show(event) {
    event.preventDefault()
    this.dispatch("show", { 
        detail: { 
            url: this.urlValue,
            filename: this.filenameValue,
            contentType: this.contentTypeValue
        } 
    })
  }

  // --- STAGE MANAGER (Modal) ---
  open(event) {
    const { url, filename, contentType } = event.detail
    const isVideo = contentType && contentType.startsWith("video/")
    if (this.hasImageTarget) {
      this.imageTarget.src = isVideo ? "" : url
      this.imageTarget.classList.toggle(this.hiddenClass, isVideo)
    }
    if (this.hasVideoTarget) {
      this.videoTarget.src = isVideo ? url : ""
      this.videoTarget.classList.toggle(this.hiddenClass, !isVideo)
      if (isVideo) {
        this.videoTarget.load() //evalute current video src attribute
        this.videoTarget.play()
      }
    }
    if (this.hasDownloadButtonTarget) {
      this.downloadButtonTarget.href = url
      this.downloadButtonTarget.download = filename
    }
    this.element.classList.remove(this.hiddenClass)
    document.body.classList.add(this.scrollLockClass)
  }

  close() {
    this.element.classList.add(this.hiddenClass)
    document.body.classList.remove(this.scrollLockClass)
    if (this.hasVideoTarget) {
      this.videoTarget.pause()
      this.videoTarget.src = "" 
      this.videoTarget.load()
    }
  }

  stop(event) {
    event.stopPropagation()
  }
  disconnect() {
  //kill the video
    if (this.hasVideoTarget) {
      this.videoTarget.pause()
      this.videoTarget.src = ""
      this.videoTarget.load()
    }
  }
}